import script from "./DeliveryAddressModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryAddressModal.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryAddressModal.vue?vue&type=style&index=0&id=57028001&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57028001"]])

export default __exports__